import { Base } from "./base";

export enum CartonLogType {
  SUCCESS = "success",
  ERROR = "error",
}

export enum CartonLogReason {
  NOT_FOUND = "ssccNotFound",
  FOUND = "ssccFound",
}

export interface CartonLog extends Base {
  id?: number;
  sscc: string;
  cartonId?: number;
  type: CartonLogType;
  reason: string;
  shipmentId: number;
  isReceived: boolean;
}
